export default __webpack_public_path__ + "static/media/wc.dfa25e47.svg";